import { useState, useEffect } from "react";
import ServiceService from "../../services/ServiceService/ServiceService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function useServiceFetch(serviceId) {
  const [service, setService] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchService() {
      if (typeof serviceId === "undefined") {
        setIsLoading(false);
        navigate("/services");
        return;
      }
      setIsLoading(true);
      const newService = await ServiceService.getService(serviceId);
      setIsLoading(false);

      if (newService) {
        setService(newService);
      } else {
        toast.error("Unable to find service.");
        navigate("/service");
      }
    }

    fetchService();
  }, [serviceId, navigate]);

  return {
    service,
    isLoading,
  };
}

export default useServiceFetch;
